
import { config } from 'shared/shared';
import AccountPreferences from './includes/account-preferences';
import AjaxUtils from '../../shared/util/ajax-utils';
import PackRat from '../../shared/packRat';
import IndividualLoginDropdown from '../../shared/individualLoginDropdown';
import '../../shared/google-individual-login';
require('bootstrap')
/**
 * All of the stuff in here fires on every page
 */
if ($("#individual-login-dropdown").length) {
  new IndividualLoginDropdown()
}
 // let individualLoginDropdown = ($("#individual-login-modal")) ? new IndividualLoginDropdown() : return;

// Show the Account Preferences modal

if (!config.hideAccountPreferences) {
    _.delay(AccountPreferences.show, 1000);
}


// Update the "Last Visited" date for students

if (config.isStudent()) {
    AjaxUtils.post({ url: `${config.subjectAreaPath}/save/signIn` });
}

/*-------------------------------------*/
/*-- PACKRAT ACTION TRACKING LIBRARY --*/
/*-- Turn this off in configuration.properties packrat.tracking.service=false
  - Logging can be turned off inside of javascript/app/shared/packRat.js const settings->debug
  - javascript/app/shared/packRat.js
This is now running on dev server running on nodejs.  If you are seeing
errors the server might have gone down and not restarted.
/*-------------------------------------*/

/*--
PackRat is only run when the isPackRat is set to true and the user is a
student.
--*/
if (!!PackRat.SETTINGS.ACTIVATED && config.isStudent()) {
  PackRat.log(`The API location is located at ${PackRat.SETTINGS.API_SERVER}`);
  PackRat.log("I am a student, and PackRat is logging...");
  PackRat.log(`I am student ${config.individualId}`)
  /*--
    PackRat is made up of viewers, episodes, scenes, and actions
    each child is dependent on it's parent's in order to exist. Scene, episode,
    and, viewer information are stored in sessionStorage. If there is already
    a scene or episode, than the viewer has already been setup and we will
    have that viewer's unique ID in sessionStorage.
  --*/


/*--
First determine if there are any scenes currently going.  Since scenes are
Fremoved from local storage when they are completed this is a good first step
in figuring out whether a viewer has been processed and an episode has been
processed.
--*/


  /*--
      Check to see if the user has been assigned a uuid and if it stored in
      session storage.
  --*/
  if (typeof PackRat.getViewerId() === 'undefined') { //No uuid exists
    /*--
    Go get a new uuid for the current viewer. This will be unique per
    user request, so if the same individual id is requested, a differen't
    UUID will be returned, because the system assumes that this is a new
    instance of the user visiting the site. The UUID is stored in session storage
    so it will be wiped out when the browser is closed or someone navigates alway
    from the site.  An episode is also initiated and started which can be traced
    to a user by uuid.
    --*/
    PackRat.log('I do not yet have a viewer id.');
    PackRat.getViewer(config.individualId).then((response) => {
      sessionStorage.setItem('PackRat', response);
      PackRat.log(`My unique viewer id is: ${sessionStorage.getItem('PackRat')}`);
      PackRat.log(`My assigned unique episode id is ${PackRat.getEpisodeId()}`);
      let detectScene = PackRat.detectScene();
      PackRat.examineScene(detectScene);
      //We wont have any scenes in this instnce, but should we start one?
    });
  }
  else {
    /*--
    A unique uuid has already been assigned to this user for this session.  The
    viewer's unique episode will have their modified date time updated based on
    the UUID.  We can fall back to this to end events if an episode or a scene
    ends unexpectedly without adding an entry to the database.
    --*/
    PackRat.log(`I already have a unique viewer id of ${PackRat.getViewerId()}`);
    PackRat.log(`My assigned unique episode id is ${PackRat.getEpisodeId()}`);
    PackRat.updateEpisodeModifiedDate(PackRat.getViewerId()).then((response) => {
      let modifiedDate = moment(parseInt(response.data[0].modified_date, 10)).format('YYYY-MM-DD HH:mm:SS Z');
      PackRat.log(`Episode updated at ${modifiedDate}`);
      let detectScene = PackRat.detectScene();
      //We could have ongoing scenes in this instance, we might need to start
      //a new one, stop an existing one, or do nothing.
      PackRat.examineScene(detectScene);
    });
  }

}



// WEBPACK FOOTER //
// ./javascript/app/page/common/common.js